import useInterval from 'hooks/useInterval'
import { DateDifference, dateDifference } from 'lib/datetime/dateUtils'
import React, { useState } from 'react'

interface Props {
  salesEndDate: string
}

function OfferCalendarFlightDealBannerCountdown(props: Props) {
  const { salesEndDate } = props
  const [timeRemaining, setTime] = useState<DateDifference>(dateDifference(new Date(salesEndDate)))

  useInterval(() => {
    setTime(dateDifference(new Date(salesEndDate)))
  }, 1000, { disabled: new Date() > new Date(salesEndDate) })

  if (timeRemaining.days < 1) {
    return <>
      {Math.max(timeRemaining.hours, 0)}H : {Math.max(timeRemaining.minutes, 0)}M : {Math.max(timeRemaining.seconds, 0)}S
    </>
  }

  return <>{timeRemaining.days} days</>
}

export default React.memo(OfferCalendarFlightDealBannerCountdown)
